module.exports = __webpack_public_path__ + "img/rsvp.44e32456.webp";